/**
 * SASS
 */
import '../sass/frontend.scss';

/**
 * Node Modules
 */
import 'slick-carousel';
import 'magnific-popup';
import 'jquery.cookie';
//import { gsap, ScrollTrigger } from "gsap/all";
//gsap.registerPlugin(ScrollTrigger, Draggable, Flip, MotionPathPlugin); 


/**
 * Components
 */
import { popup } from './components/popup.js';
import { promoGate } from './components/promoGate.js';
import { blocks } from './components/blocks.js';
import { initSlideShows } from './components/slideshow.js';
import { navigation } from './components/nav.js';
import { messageBar } from './components/messageBar.js';
import { aos } from './components/aos.js';
import { copyURL } from './components/copy-urls.js';
// import { thingsCallout } from './components/thingsCallout.js';
import {facetSearch, searchButton } from './components/searchFilter.js';

/**
 * JS
 */
$(function() {
    aos();
    copyURL();
    navigation();
    blocks();
    initSlideShows();
    messageBar();
    popup();
    // thingsCallout();
    facetSearch();
    searchButton();
    promoGate();
    
    $('html').addClass('loaded');
    
    window.onbeforeunload = function(){
        $('html').removeClass('loaded');
    };
});

 